import { defineMessages } from 'react-intl-next';

const _default_1: {
	itemCreationDisabledTooltipText: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	newItemButtonText: {
		defaultMessage: string;
		description: string;
		id: string;
	};
} = defineMessages({
	newItemButtonText: {
		id: 'company-hub.links-menu-extension.config-panel.new-item-button.text',
		defaultMessage: 'New item',
		description:
			'Text for the add new item button in the Links Menu configuration panels Items tab section',
	},
	itemCreationDisabledTooltipText: {
		id: 'company-hub.links-menu-extension.config-panel.new-item-button.disabled.tooltip-text',
		defaultMessage:
			'You have reached the maximum number of items that can be added to a links menu.',
		description:
			'Text on a tooltip over a disabled button that would normally allow user to create new items, explaining that they have hit the limit for item creation',
	},
});
export default _default_1;
